export default function getCurrentGroupId(state: any) {
  return state.getIn(['currentGroup', 'data', 'id']);
}
